<div class="menu-bar">
  <div *ngFor="let menuEntry of menuEntries"
       class="menu-entry"
      [class.active]="menuEntry.isActive"
      [ngbTooltip]="(menuEntry.label | translate)" placement="right" container="body" tooltipClass="menu-tooltip">

    <a class="menu-entry-link" [routerLink]="menuEntry.path">
      <div class="menu-entry-icon" [ngClass]="menuEntry.icon"></div>
      <div class="menu-entry-name">{{menuEntry.label | translate}}</div>
    </a>

  </div>
</div>

